<template>
  <div
    v-if="toggle.userExamDocument"
    class="status-icon document-flag-container"
    :class="'document-flag-container--' + status"
  >
    <md-tooltip
      md-delay="400"
      md-direction="top"
    >
      <span v-if="!isDocumentDelivered">
        Há exame(s) com <br>
        documento(s) pendente(s).
        <br>Clique aqui para exibi-los.
      </span>
      <span v-else>Documento(s) anexado(s).</span>
    </md-tooltip>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'DocumentFlag',
  props: {
    isDocumentDelivered: Boolean
  },
  computed: {
    ...mapGetters(['toggle']),
    status: function () {
      return this.isDocumentDelivered ? 'uploaded' : 'missing'
    }
  }
}
</script>

<style lang="scss">
.document-flag {
  &-container {
    display: inline-block;
    width: 30px;
    height: 30px;
    cursor: pointer;
    border-radius: 5px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 27px;

    &--missing {
      background-image: url(/static/images/icon-doc.svg);
    }

    &--uploaded {
      background-image: url(/static/images/icon-doc-attached.svg);
    }
  }
}
</style>

